import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import _ from 'lodash';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import SaveCustomerOrderDevices from '../../../services/SaveCustomerOrderDevices';
import PRTNRDeviceSectionView from '../../../views/PRTNRDeviceSectionView';
import ReloadViewModule from '../../../services/ReloadViewModule';

import tmplPRTNRFormView from './PRTNRFormView.hbs';

const PRTNRFormView = View.extend({
  template: tmplPRTNRFormView,

  ui: {
    a3NIPRSection: '.a3-nipr-section',
    a3SIPRSection: '.a3-sipr-section',
    a3ServicesSection: '.a3-services-section',
    a4NIPRSection: '.a4-nipr-section',
    a4SIPRSection: '.a4-sipr-section',
    a4ServicesSection: '.a4-services-section',
    prodNIPRSection: '.prod-nipr-section',
    prodSIPRSection: '.prod-sipr-section',
    prodServicesSection: '.prod-services-section',
    devicesAlert: '.no-devices-error'
  },

  regions: {
    a3NIPRSection: '@ui.a3NIPRSection',
    a3SIPRSection: '@ui.a3SIPRSection',
    a3ServicesSection: '@ui.a3ServicesSection',
    a4NIPRSection: '@ui.a4NIPRSection',
    a4SIPRSection: '@ui.a4SIPRSection',
    a4ServicesSection: '@ui.a4ServicesSection',
    prodNIPRSection: '@ui.prodNIPRSection',
    prodSIPRSection: '@ui.prodSIPRSection',
    prodServicesSection: '@ui.prodServicesSection'
  },

  className: 'prtnr-form-view',

  onRender() {
    const orderType = this.model.get('orderDetails').orderTypeId;

    const { A3NIPR, A3SIPR, A3Services, A4NIPR, A4SIPR, A4Services, ProdNIPR, ProdSIPR, ProdServices } = _.groupBy(
      this.model.get('lineItems'),
      'panel'
    );

    this.showChildView(
      'a3NIPRSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: A3NIPR,
          title: 'A3 NIPR Devices',
          orderType,
          type: 'devices',
          contract: 'A3',
          id: 'A3-NIPR'
        })
      })
    );

    this.showChildView(
      'a3SIPRSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: A3SIPR,
          title: 'A3 SIPR Devices',
          orderType,
          type: 'devices',
          contract: 'A3',
          id: 'A3-SIPR'
        })
      })
    );

    this.showChildView(
      'a3ServicesSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: A3Services,
          title: 'A3 Additional Services',
          orderType,
          type: 'services',
          contract: 'A3',
          id: 'A3-Services'
        })
      })
    );

    this.showChildView(
      'a4NIPRSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: A4NIPR,
          title: 'A4 NIPR Devices',
          orderType,
          type: 'devices',
          contract: 'A4',
          id: 'A4-NIPR'
        })
      })
    );

    this.showChildView(
      'a4SIPRSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: A4SIPR,
          title: 'A4 SIPR Devices',
          orderType,
          type: 'devices',
          contract: 'A4',
          id: 'A4-SIPR'
        })
      })
    );

    this.showChildView(
      'a4ServicesSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: A4Services,
          title: 'A4 Additional Services',
          orderType,
          type: 'services',
          contract: 'A4',
          id: 'A4-Services'
        })
      })
    );

    this.showChildView(
      'prodNIPRSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: ProdNIPR,
          title: 'Production NIPR Devices',
          orderType,
          type: 'devices',
          contract: 'Prod',
          id: 'Prod-NIPR'
        })
      })
    );

    this.showChildView(
      'prodSIPRSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: ProdSIPR,
          title: 'Production SIPR Devices',
          orderType,
          type: 'devices',
          contract: 'Prod',
          id: 'Prod-SIPR'
        })
      })
    );

    this.showChildView(
      'prodServicesSection',
      new PRTNRDeviceSectionView({
        model: new Backbone.Model({
          lineItems: ProdServices,
          title: 'Production Additional Services',
          orderType,
          type: 'services',
          contract: 'Prod',
          id: 'Prod-Services'
        })
      })
    );
  },

  showSaveError() {
    showErrorMessage({
      errorCode: 'saveError',
      errorTitle: 'Save Error',
      errorMessage:
        'An error occurred while saving devices for this order. Try again or contact an administrator if your issue persists.'
    });
  },

  showSaveSuccess() {
    showSuccessMessage({
      code: 'saveSuccess',
      title: 'Save Success',
      message: 'This order has been saved successfully.',
      hideAfter: 5
    });
  },

  async validate() {
    const a3NiprColl = await this.getChildView('a3NIPRSection').getDeviceData();
    const a3SiprColl = await this.getChildView('a3SIPRSection').getDeviceData();
    const a3ServicesColl = await this.getChildView('a3ServicesSection').getDeviceData();
    const a4NiprColl = await this.getChildView('a4NIPRSection').getDeviceData();
    const a4SiprColl = await this.getChildView('a4SIPRSection').getDeviceData();
    const a4ServicesColl = await this.getChildView('a4ServicesSection').getDeviceData();
    const prodNiprColl = await this.getChildView('prodNIPRSection').getDeviceData();
    const prodSiprColl = await this.getChildView('prodSIPRSection').getDeviceData();
    const prodServicesColl = await this.getChildView('prodServicesSection').getDeviceData();

    const totalMonoQuantity =
    a3NiprColl.totalMonoQuantity +
    a3SiprColl.totalMonoQuantity +
    a4NiprColl.totalMonoQuantity +
    a4SiprColl.totalMonoQuantity +
    prodNiprColl.totalMonoQuantity +
    prodSiprColl.totalMonoQuantity;

    const totalColorQuantity =
    a3NiprColl.totalColorQuantity +
    a3SiprColl.totalColorQuantity +
    a4NiprColl.totalColorQuantity +
    a4SiprColl.totalColorQuantity +
    prodNiprColl.totalColorQuantity +
    prodSiprColl.totalColorQuantity;

    const totalMonthlyAdditionalServicesQuantity =
    a3ServicesColl.totalMonthlyAdditionalServicesQuantity +
    a4ServicesColl.totalMonthlyAdditionalServicesQuantity +
    prodServicesColl.totalMonthlyAdditionalServicesQuantity;

    const totalYearlyOneTimeServicesQuantity =
    a3ServicesColl.totalYearlyOneTimeServicesQuantity +
    a4ServicesColl.totalYearlyOneTimeServicesQuantity +
    prodServicesColl.totalYearlyOneTimeServicesQuantity;

    let isValid = true;
    if (!totalMonoQuantity && !totalColorQuantity && !totalMonthlyAdditionalServicesQuantity && !totalYearlyOneTimeServicesQuantity) {
      isValid = false;
      this.ui.devicesAlert.show();
    }
    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async onSave() {
    this.ui.devicesAlert.hide();
    this.trigger('no:errors')
    const a3NiprColl = await this.getChildView('a3NIPRSection').getDeviceData();
    const a3SiprColl = await this.getChildView('a3SIPRSection').getDeviceData();
    const a3ServicesColl = await this.getChildView('a3ServicesSection').getDeviceData();
    const a4NiprColl = await this.getChildView('a4NIPRSection').getDeviceData();
    const a4SiprColl = await this.getChildView('a4SIPRSection').getDeviceData();
    const a4ServicesColl = await this.getChildView('a4ServicesSection').getDeviceData();
    const prodNiprColl = await this.getChildView('prodNIPRSection').getDeviceData();
    const prodSiprColl = await this.getChildView('prodSIPRSection').getDeviceData();
    const prodServicesColl = await this.getChildView('prodServicesSection').getDeviceData();

    const devicesFormData = a3NiprColl.changedItems.concat(
      a3SiprColl.changedItems,
      a3ServicesColl.changedItems,
      a4NiprColl.changedItems,
      a4SiprColl.changedItems,
      a4ServicesColl.changedItems,
      prodNiprColl.changedItems,
      prodSiprColl.changedItems,
      prodServicesColl.changedItems
    );

    const formData = {
      devicesFormData,
      orderId: this.model.get('orderDetails').orderId,
      orderTypeId: this.model.get('orderDetails').orderTypeId,
      itPocExists: true
    };

    try {
      await SaveCustomerOrderDevices(formData);
      await ReloadViewModule.reload();
      this.showSaveSuccess();
    } catch (err) {
      this.showSaveError();
      throw new Error(err);
    }
  }
});

export default PRTNRFormView;
